import MiiaFwConfig from '@/configs/config'
import { useApiGw } from '@/modules/miiaFw/composables/useApiGw'
import * as paramTypes from '@/types/accessor/api/s3/s3'

/**
 * S3APIへのアクセス処理
 * @param リクエストパラメータ
 * @returns 関数の処理結果 or エラー
 */
export const callApi = async <T, U>(
  body: paramTypes.Request<T>
): Promise<paramTypes.Response<U>> => {
  return await new Promise((resolve, reject) => {
    const { invokeApiGwFunc } = useApiGw()
    invokeApiGwFunc(
      // API Gatewayのエンドポイント
      MiiaFwConfig.config.apiGwEndpointCommon,
      // Lambda関数をコールするためのWebAPIのサブディレクトリ
      '/s3',
      // Lambda関数に渡す引数
      {
        function: body.function,
        params: { ...body.params, system: 'disaster-emergency' }
      },
      // Lambda関数実行前の前処理のコールバック
      () => {},
      // 成功時のコールバック
      (data: { result: U }) => {
        resolve(data.result)
      },
      // 例外受信時のコールバック(引数: エラーメッセージ)
      err => {
        reject(err)
      },
      // 予期せぬエラー(アクセス回線障害など)発生時のコールバック
      () => {
        reject({ message: 'API実行に失敗しました。(原因: アクセス回線障害など)' })
      },
      // 処理完了後に実行するコールバック
      () => {},
      false,
      true
    )
  })
}
